<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{ $t('edit.hpInfo.video') }}</div>
    </div>

    <div class="tool-drawer-content">
      <IconSelect
        :currentIcon="videoObj.icon_url"
        @onSelectIcon="onSelectIcon"
      ></IconSelect>

      <div class="tit-box">
        <div>
          <div style="margin-bottom: 5px">
            <span>{{ $t('edit.hpInfo.IconScale') }}</span>
          </div>
          <a-row class="titleScaleBg">
            <a-col :span="24">
              <a-slider :min="1" :max="300" :step="1" v-model="currScale" />
            </a-col>
          </a-row>
        </div>
        <div class="tit-desc">
          <span>{{ $t('edit.title') }}</span>
          <a-checkbox
            :checked="videoObj.is_show_title === 1"
            @change="isShowTitle"
          >
            {{ $t('edit.hpInfo.showTitle') }}
          </a-checkbox>
        </div>
        <div style="background-color: #212121">
          <div class="tit-desc-px">
            <a-input
              :placeholder="$t('edit.hpInfo.inputTitle')"
              v-model="currTitle"
            />
            <div class="tit-px">
              <a-input
                class="title-input"
                :placeholder="currFontSize"
                v-model="currFontSize"
              />
              <span style="padding-left: 2px">px</span>
            </div>
          </div>
          <div class="tit_position_bg">
            <a-button
              class="tit_position_btn"
              type="primary"
              v-for="(item, index) in btnPosition"
              :key="index"
              @click="onClickBtn(item, index)"
              :class="{ tit_active: index == currentPosition }"
            >
              {{ item.name }}
            </a-button>
          </div>
        </div>
        <div class="tit_sliderbar_bg">
          <a-row>
            <a-col :span="6" style="padding: 5px">
              {{ $t('edit.hpInfo.title_x') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_x" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" style="padding: 5px">
              {{ $t('edit.hpInfo.title_y') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_y" />
            </a-col>
          </a-row>
        </div>
      </div>

      <div style="margin: 20px 20px 0">
        <div style="display: flex; justify-content: space-between">
          <span style="margin-bottom: 8px">{{ $t('edit.video') }}</span>
          <a-checkbox
            :checked="videoObj.is_auto_play === 1"
            @change="isAutoPlay"
          >
            自動播放
          </a-checkbox>
        </div>
        <material-select :type="3" @selected="handleSelectedVideo">
          <template slot="body">
            <a-button type="primary" ghost>
              {{ $t('edit.hpInfo.videoSelect') }}
            </a-button>
          </template>
        </material-select>
      </div>

      <div class="image-list" v-if="videoObj.content && videoObj.content.url">
        <video id="myVideo" :src="videoObj.content.url" width="200" />
        <div class="material-option">
          <span class="m-title">{{ videoObj.content.name }}</span>
          <span class="m-dele" @click="onClickDel">
            {{ $t('actionTitles.delete') }}
          </span>
        </div>
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn
        @onClickSave="onClickSave"
        @onClickCancel="clickDelete"
      ></DoubleBtn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IconSelect from './IconSelect.vue';
import MaterialSelect from '@/components/MaterialSelect';
import { v4 as uuidv4 } from 'uuid';
import DoubleBtn from '../DoubbleBtn';

export default {
  components: { IconSelect, MaterialSelect, DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      btnPosition: [
        { name: '上', align: 'top', edge: 'bottom', x: 0, y: 0 },
        { name: '下', align: 'bottom', edge: 'top', x: 0, y: 0 },
        { name: '左', align: 'left', edge: 'right', x: 0, y: 0 },
        { name: '右', align: 'right', edge: 'left', x: 0, y: 0 },
      ],
      currentPosition: 0,
      // selectIcon: "",
      // currentVideo: null,
      // titleStr: "",
      videoObj: {
        type: 'video',
        hotspot_id: 'hotspot_' + uuidv4(),
        icon_url: '',
        is_dynamic: 0,
        ath: '',
        atv: '',
        title: '',
        is_show_title: 1,
        is_auto_play: 1,
        content: {},
        titleFontSize: 14,
        tit_position_align: 'top',
        tit_position_edge: 'bottom',
        tit_position_x: 0,
        tit_position_y: 0,
        icon_scale: 50,
      },
      currTitle: '',
      currFontSize: 16,
      currScale: 50,
      curr_align: 'top',
      curr_edge: 'bottom',
      curr_x: 0,
      curr_y: 0,
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.videoObj = value;
          this.currFontSize = this.videoObj.titleFontSize;
          this.currScale = this.videoObj.icon_scale;
          this.curr_x = this.videoObj.tit_position_x;
          this.curr_y = this.videoObj.tit_position_y;
          this.currTitle = this.videoObj.title;
          // console.log(this.videoObj);
          if (this.videoObj.tit_position_align == 'top') {
            this.currentPosition = 0;
          } else if (this.videoObj.tit_position_align == 'bottom') {
            this.currentPosition = 1;
          } else if (this.videoObj.tit_position_align == 'left') {
            this.currentPosition = 2;
          } else if (this.videoObj.tit_position_align == 'right') {
            this.currentPosition = 3;
          } else {
            // If tit_position_align is not defined, default to 'top'
            this.currentPosition = 0;
            this.videoObj.tit_position_align = 'top';
          }
        }
      },
      immediate: true,
      deep: true,
    },
    newVideoObj: {
      handler: function (val, oldVal) {
        if (val.ath == '' && val.atv == '') {
          const vh = getSceneViewAt();
          this.videoObj.ath = vh.hlookat;
          this.videoObj.atv = vh.vlookat;
        }
        this.$emit('change', this.videoObj, oldVal);
      },
      deep: true,
    },
    currTitle: {
      handler: function (value) {
        const id = this.videoObj.hotspot_id;
        setTitle(id, value);
      },
      deep: true,
    },
    currScale: {
      handler: function (value) {
        const id = this.videoObj.hotspot_id;
        setIconScale(id, value);
      },
      deep: true,
    },
    currFontSize: {
      handler: function (value) {
        const id = this.videoObj.hotspot_id;
        const css = 'css';
        var value =
          'text-align:center; color:#FFFFFF; font-family:MicrosoftYahei; font-size:' +
          value +
          'px';
        setTitlePosition(id, value, css);
      },
      deep: true,
    },
    curr_x: {
      handler: function (value) {
        const id = this.videoObj.hotspot_id;
        // const x = 'x';
        // setTitlePosition(id, value, x);

        const axis = 'x';
        // 若左右對立，送反號
        const send = this.isOppositeX(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
    curr_y: {
      handler: function (value) {
        const id = this.videoObj.hotspot_id;
        // const y = 'y'
        // setTitlePosition(id, value, y);

        const axis = 'y';
        // 若上下對立，送反號
        const send = this.isOppositeY(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['vrbase', 'currentScenesId', 'userInfo']),
    newVideoObj() {
      return this.$deepClone(this.videoObj);
    },
  },
  mounted() {
    this.$bus.$on('updateHotspot', (e) => {
      if (e.hotspot_id == this.videoObj.hotspot_id) {
        this.videoObj.ath = e.ath;
        this.videoObj.atv = e.atv;
      }
    });
  },
  methods: {
    isOppositeY(align, edge) {
      return align === 'bottom' && edge === 'top';
    },
    isOppositeX(align, edge) {
      return align === 'right' && edge === 'left';
    },
    onClickBtn(item, index) {
      this.currentPosition = index;
      const currId = this.videoObj.hotspot_id;

      // 重新把目前的 x/y（滑桿數值）送進 krpano，但在送之前做對立翻號
      const sendX = this.isOppositeX(this.curr_align, this.curr_edge)
        ? -this.curr_x
        : this.curr_x;
      const sendY = this.isOppositeY(this.curr_align, this.curr_edge)
        ? -this.curr_y
        : this.curr_y;

      // 再把調整後的位移送進 krpano
      setTitlePosition(currId, sendX, 'x');
      setTitlePosition(currId, sendY, 'y');

      setHotspotTitlePosition(item, currId);
      this.curr_align = item.align;
      this.curr_edge = item.edge;
      this.curr_x = item.x;
      this.curr_y = item.y;
    },
    onSelectIcon(item) {
      this.videoObj.icon_url = item.icon_url;
      this.videoObj.is_dynamic = item.is_dynamic;
    },

    handleChange() {},
    onChange() {},
    isShowTitle(e) {
      this.videoObj.is_show_title = e.target.checked ? 1 : 0;
    },
    isAutoPlay(e) {
      this.videoObj.is_auto_play = e.target.checked ? 1 : 0;
    },
    titleChange(e) {
      console.log(e.target.value);
    },
    clickBack() {
      this.$emit('clickBack', this.videoObj);
    },
    clickDelete() {
      this.$emit('clickDelete', this.videoObj);
    },
    handleSelectedVideo(value) {
      this.videoObj.content = { name: value.name, url: value.url };
    },
    onClickSave() {
      this.videoObj.title = this.currTitle;
      this.videoObj.titleFontSize = this.currFontSize;
      this.videoObj.icon_scale = this.currScale;
      this.videoObj.tit_position_align = this.curr_align;
      this.videoObj.tit_position_edge = this.curr_edge;
      this.videoObj.tit_position_x = this.curr_x;
      this.videoObj.tit_position_y = this.curr_y;
      if (!this.videoObj.icon_url) {
        this.$message.error(this.$t('edit.hpInfo.hpIcon'));
        return;
      }
      if (!this.videoObj.title) {
        this.$message.error(this.$t('edit.hpInfo.inputTitle'));
        return;
      }
      if (!this.videoObj.content.url) {
        this.$message.error(this.$t('edit.hpInfo.videoSelect'));
        return;
      }
      // this.videoObj.title = this.titleStr;

      this.$emit('saveDataToStore', {
        key: this.videoObj.hotspot_id,
        data: this.videoObj,
      });
    },
    onClickDel() {
      this.videoObj.content = {};
    },
  },
};
</script>

<style lang="less" scoped>
.image-list {
  padding: 10px 4px;
  text-align: center;
}
.image-list img {
  object-fit: contain;
  width: 200px;
}
.material-option {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  cursor: pointer;
}
.m-title {
  width: 180px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.m-dele {
  width: 30px;
}
.title-input {
  text-align: center;
  width: 50%;
}
.tit-desc-px {
  display: inline-flex;
  align-items: center;
  padding: 5px;
}
.tit-px {
  text-align: right;
}
.title-type {
  width: 80%;
}
.tit_position_bg {
  height: 49px;
  background-color: #212121;
  width: 100%;
  display: flex;
  .positionBtn.tit_active {
    background-color: #7101ad;
    border-color: #7101ad;
  }
  .positionBtn:hover {
    background-color: #d485ff;
    border-color: #d485ff;
  }
}
.tit_position_btn {
  color: #fff;
  background-color: #404040;
  border-color: #2e2e2e;
  margin: 10px 4px;
  border: 1px solid;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #555;
}
.tit_position_btn:hover {
  background-color: #02a2aa;
  border-color: #02a2aa;
  border: 1px solid #fff;
}
.tit_active {
  background-color: #015c61;
  border-color: #015c61;
}
.tit_sliderbar_bg {
  height: auto;
  background-color: #212121;
  width: 100%;
}
.titleScaleBg {
  background-color: #212121;
}
</style>
